import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import { Button } from "common/src/styles";
const NotFoundBanner = /*#__PURE__*/React.lazy(() => import("../../assets/404"));
import { datadogLogs } from "@datadog/browser-logs";
import Footer from "common/src/components/Footer";
import React, { Suspense } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function NotFoundPage() {
  datadogLogs.logger.info(`====> Route: NotFound`);
  datadogLogs.logger.info(`====> URL: ${window.location.href}`);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {}), /*#__PURE__*/_jsxs("div", {
      className: "relative top-16 lg:mx-20 h-screen px-4 py-7",
      children: [/*#__PURE__*/_jsx("main", {
        children: /*#__PURE__*/_jsx("div", {
          className: "flex pt-8",
          children: /*#__PURE__*/_jsxs("div", {
            className: "m-auto text-center mt-5",
            children: [/*#__PURE__*/_jsx("h1", {
              className: "my-5 text-sm text-red-100 font-bold",
              children: "404 ERROR"
            }), /*#__PURE__*/_jsx("h2", {
              className: "my-5 text-4xl",
              children: "Uh oh! You might be a little lost"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-grey-400 mb-0",
              children: "It looks like the page you\u2019re looking for doesn\u2019t exist."
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-grey-400 mt-1 mb-5",
              children: ["For support, contact us on", " ", /*#__PURE__*/_jsx("a", {
                href: "https://discord.com/invite/gitcoin",
                children: "Discord."
              })]
            }), /*#__PURE__*/_jsx(Link, {
              to: "/",
              "data-testid": "not-found-go-back-home",
              children: /*#__PURE__*/_jsx(Button, {
                $variant: "outline",
                type: "button",
                className: "px-3 bg-violet-100 text-violet-400 border-0 text-xs",
                children: "Go back home"
              })
            }), /*#__PURE__*/_jsx(Suspense, {
              fallback: /*#__PURE__*/_jsx("div", {
                style: {
                  width: "502px",
                  height: "360px"
                }
              }),
              children: /*#__PURE__*/_jsx(NotFoundBanner, {
                className: "max-w-full"
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Footer, {})]
    })]
  });
}